import type { DraftInput } from '../../../../shared/drafts';
import { LANE_RALLY_RULES } from '../../../../shared/laneRallyRules';
function question(level: number): DraftInput['questions'][number] {
  return { prompt: `${level}. yarış sorusu`, levels: [level], timeLimitSeconds: null,
    choices: [{ text: 'Doğru cevap', isCorrect: true }, { text: 'Yanlış cevap 1', isCorrect: false }, { text: 'Yanlış cevap 2', isCorrect: false }] };
}
export function createLaneRallyDraft(): DraftInput {
  return { title: 'Yeni Şerit Rallisi', templateKey: 'lane-rally', levelMode: 'manual', maxLevels: 5, trackTime: true,
    timingMode: 'none', questions: Array.from({ length: 5 }, (_, i) => question(i + 1)) };
}
export function resizeLaneRallyDraft(draft: DraftInput, count: number): DraftInput {
  const maxLevels = Math.max(LANE_RALLY_RULES.minQuestions, Math.min(LANE_RALLY_RULES.maxQuestions, Math.trunc(count)));
  // Tabela süresi öğretmen ayarı değildir (sabit düzen, gaz bırakınca süresiz düşünme); eski değerler temizlenir.
  return { ...draft, timingMode: 'none', trackTime: true, maxLevels, questions: Array.from({ length: maxLevels }, (_, i) =>
    ({ ...(draft.questions.find(q => q.levels[0] === i + 1) ?? question(i + 1)), levels: [i + 1], timeLimitSeconds: null })) };
}
